import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { CellSelection } from '@tiptap/pm/tables';

const TableCellSelection = Extension.create({
  name: 'tableCellSelection',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('tableCellSelection'),
        appendTransaction(transactions, oldState, newState) {
          // Only process if selection changed
          if (!transactions.some(tr => tr.selectionSet)) {
            return null;
          }

          const { selection } = newState;

          // Already a cell selection, nothing to do
          if (selection instanceof CellSelection) {
            return null;
          }

          // Check if selection spans multiple table cells
          const { $from, $to } = selection;

          // Find the table cell containing a resolved position by walking up the depth
          const findCellPos = ($pos: typeof $from): number | null => {
            for (let d = $pos.depth; d > 0; d -= 1) {
              const node = $pos.node(d);
              if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') {
                return $pos.before(d);
              }
            }
            return null;
          };

          const fromCell = findCellPos($from);
          const toCell = findCellPos($to);

          // If both ends are in table cells and they're different cells
          if (fromCell !== null && toCell !== null && fromCell !== toCell) {
            // Convert to cell selection
            try {
              const cellSelection = CellSelection.create(newState.doc, fromCell, toCell);
              return newState.tr.setSelection(cellSelection);
            } catch {
              // If cell selection creation fails, leave selection as is
              return null;
            }
          }

          return null;
        }
      })
    ];
  }
});

export default TableCellSelection;
